import React, { useState, useCallback} from 'react';
import {connect} from 'react-redux';
import {Knob, Arc, Pointer, Value} from 'rc-knob';
import {changeTranspose} from 'engine/mix/actions.js';
import Colors from 'components/Colors.js';

const colors = new Colors();

const TransposeKnob = ({sequencerEngine, value, id}) => {
    const onChange = useCallback((v) => {
        v = Math.round(v);
        if (v === value) {
            return;
        }
        sequencerEngine.multiSequencerEngine.dispatch(
            changeTranspose(
                sequencerEngine.sequenceId,
                v));
    }, [sequencerEngine, value]);

    let color = colors.getColorForHash(id || 'what');
    return (
        <div className="transpose-container">
            <Knob 
              size={50}  
              angleOffset={220} 
              angleRange={280}
              value={value}
              initialValue={value}
              step={1}
              min={-24}
              max={24}
              onChange={onChange}
              >
              <Arc 
                arcWidth={3}
                color={color}
                background="rgb(56, 63, 72)"
                />
              <Pointer 
                width={3} 
                height={15}
                radius={10}
                type="rect"
                color={color}
                />
             <Value className="transpose-value"/>
            </Knob>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        value: state.explore.workTransposes[props.sequencerEngine.sequenceId] || 0
    };
};

export default connect(mapStateToProps, null)(TransposeKnob);
